import { FunctionComponent, ReactElement } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getUserRole } from '@/shared/utils';
import { RoleTypes } from '@/app/api/role/role.types';

const ClientsGuard: FunctionComponent = (): ReactElement => {
	const { role } = getUserRole();

	if (role !== RoleTypes.advisor) {
		return <Navigate to="/advisors" />;
	}

	return <Outlet />;
};

export default ClientsGuard;
